import Icon from '../../components/Icon.vue'

Icon.register({"brands/js":{"width":448,"height":512,"paths":[{"d":"M0 32V480H448V32H0zM243.8 381.4C243.8 425 218.2 444.9 180.9 444.9 147.2 444.9 127.7 427.5 117.7 406.4L152 385.7C158.6 397.4 164.6 407.3 179.1 407.3 192.9 407.3 201.7 401.9 201.7 380.8V237.7H243.8V381.4zM343.4 444.9C304.3 444.9 279 426.3 266.7 401.9L301 382.1C310 396.8 321.8 407.7 342.5 407.7 359.9 407.7 371.1 399 371.1 386.9 371.1 372.5 359.7 367.4 340.4 358.9L329.9 354.4C299.5 341.5 279.4 325.2 279.4 290.9 279.4 259.3 303.5 235.3 341 235.3 367.8 235.3 387 244.6 400.8 269L368 290C360.8 277.1 353 272 340.9 272 328.6 272 320.8 279.8 320.8 290 320.8 302.6 328.6 307.7 346.7 315.6L357.2 320.1C393 335.4 413.1 351.1 413.1 386.3 413.1 424.1 383.3 444.9 343.4 444.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/js.js
// module id = n16k
// module chunks = 0